import OSS from 'ali-oss'
let url = 'https://hbyoss.houbaoyan.cn'
function uploadFile(path,file,successCallback) {
  //原文件名
  var fileNameOrigin = file.name;
  //生成随机文件名
  var randStr = "";
  for (var i = 0; i < 16; i++) {
    var randItem = Math.floor(Math.random() * 10);
    randStr += randItem;
  }
  var randStr = randStr + '';
  //文件后缀
  var suffix = fileNameOrigin.substring(fileNameOrigin.lastIndexOf('.'), fileNameOrigin.length);
  let date = new Date();
  var year = date.getFullYear();  // 获取完整的年份(4位,1970)
  var month = date.getMonth() + 1;  // 获取月份(0-11,0代表1月,用的时候记得加上1)
  var data = date.getDate();    //获取日
  //生成完整的随机文件名称+后缀
  var filesName = year + '_' + month + '_' + data + '_' + randStr + suffix;
  //oss上传
  new OSS({
    region: 'oss-cn-beijing',
    accessKeyId: 'LTAI4G7v6W2MJ8TrWub24GJ1',
    accessKeySecret: 'LBp6y1FdopPQ2piyHiMAT3hEzz5jaC',
    bucket: 'hby-oss',
  }).put(path + filesName, file).then(function (r1) {
    //上传成功后，返回给调用者 在oss中的存储访问地址
    console.log('【ossUtil】 file:',  filesName);
    successCallback(filesName,url + path + filesName);
  }).catch(function (err) {
    console.error('ossUtil ERROR:', err);
    successCallback('','')
  });
}
export default uploadFile



// WEBPACK FOOTER //
// ./src/request/oss.js